import { differenceInCalendarDays, format } from "date-fns";

// Formats the day portion of a turn timestamp, e.g. "Yesterday". Buckets by
// calendar day relative to `now` (defaults to the current time) and renders in
// the runtime's local time zone, so the label reads naturally in the viewer's
// browser. Returns "" for an unparseable input.
export const formatTurnDay = (iso: string, now: Date = new Date()): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const days = differenceInCalendarDays(now, date);
  if (days === 0) {
    return "Today";
  }
  if (days === 1) {
    return "Yesterday";
  }
  if (days > 1 && days < 7) {
    return format(date, "EEEE");
  }
  return format(date, date.getFullYear() === now.getFullYear() ? "MMM d" : "MMM d, yyyy");
};

// Formats a turn timestamp including the time of day, e.g. "Yesterday, 5:52 PM".
// Returns "" for an unparseable input.
export const formatTurnTime = (iso: string, now: Date = new Date()): string => {
  const day = formatTurnDay(iso, now);
  if (!day) {
    return "";
  }

  return `${day}, ${format(new Date(iso), "h:mm a")}`;
};
